export const SELECTION_COLUMN = 'selection-column';
export const SELECTION_COLUMN_INVERTED = `${SELECTION_COLUMN} ${SELECTION_COLUMN}--inverted`;
